export async function wait(ms) {
    return await new Promise(resolve => setTimeout(resolve, ms));
}

class AsyncMethodQueue {
    constructor() {
        this.queue = [];
        this.isProcessing = false;
    }

    async enqueue(method) {
        this.queue.push(method);
        if (!this.isProcessing) {
            await this.processQueue();
        }
    }

    async processQueue() {
        this.isProcessing = true;
        try {
            while (this.queue.length > 0) {
                const method = this.queue.shift();
                await method();
            }
        }
        finally {
            this.isProcessing = false;
        }
    }
}

export const methodQueue = new AsyncMethodQueue();